import { createFileRoute } from '@tanstack/react-router';
import { ProfileView } from '@/features/employees/profile/profile-view';
import { profileSearchSchema } from '@/features/employees/profile/route-search';
import { guardRoute } from '@/lib/route-guards';

/** Employee profile (FR-EMP-7); the API decides scope and what is visible (AC-2, AC-3, AC-6). */
export const Route = createFileRoute('/_app/employees/$employeeId')({
  validateSearch: profileSearchSchema,
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/employees');
  },
  component: EmployeeProfilePage,
});

function EmployeeProfilePage() {
  const { employeeId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ProfileView
      employeeId={employeeId}
      tab={tab}
      breadcrumbs={[{ label: 'Employees', to: '/employees' }]}
      onTabChange={(next) => {
        void navigate({ search: { tab: next }, replace: true });
      }}
    />
  );
}
